import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/auto-reply-settings')({
    component: AutoReplyRedirect,
});

// Auto reply moved into the consolidated Scheduling page.
function AutoReplyRedirect() {
    return <Navigate to="/settings/outreach-automation" replace={true} />;
}
